
import Lottie from 'react-lottie-player';
import '../scss/pages/Landing.scss';
import individualAnimation from '../animations/individual.json';
import companyAnimation from '../animations/companyMain.json';
import Features from "./Features";
import NavBar from '../pages/NavBar';
import Contact from "./Contact";
import Footer from "./Footer";
import About from "./About";

export default function Main() {
    return(
        <div className="landing">
            <NavBar />
            <div className="landing__main">
                <div className="landing__left">
                    <Lottie
                        loop
                        animationData={individualAnimation}
                        play
                        style={{ width: 300, height: 300, margin: 'auto' }}
                    />
                    <h1 className="font1">Individuals</h1>
                    <div className="font__20">Prepare for your next interview</div>
                    <div className="text__muted">Create AI generated interviews,<br/> give answers to the interview and let AI evaluate your skills and answers.</div>
                    <div className="text__center">
                        <a className="btn btn__primary btn__rounded" href="/login/individual">
                            Get started now
                        </a>
                    </div>
                </div>
                <div className="landing__center">
                    <div className="landing__center-or">
                        <span className="content">OR</span>
                    </div>
                </div>
                <div className="landing__right">
                    <Lottie
                        loop
                        animationData={companyAnimation}
                        play
                        style={{ width: 300, height: 300, margin: 'auto' }}
                    />
                    <h1 className="font1">Companies</h1>
                    <div className="font__20">Create an interview for the first screening step</div>
                    <div className="text__muted">Create AI generated interviews,<br /> share the link with your candidates and let the AI do the evaluation.</div>
                    <div className="text__center">
                        <a className="btn btn__primary btn__rounded" href="/login/company">
                            Get started now
                        </a>
                    </div>
                </div>
            </div>
            <Features />
            <About />
            <Contact />
            <Footer />
        </div>
    )
}